const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:aaef1780-af02-4699-9544-a66cb8a53def',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_Khq0lLVyq',
    aws_user_pools_web_client_id: '7ctb1f86ik433480q92r6nqf3b',
    oauth: {},
};

export default awsmobile;